import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BasicActionsEventType } from '../DatatableEvents/basic-actions-event-type';
import { BasicActionsComponent } from '../DatatableEvents/basic-actions.component';
import { error } from 'jquery';
class DataTablesResponse {
  data: any[];
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-seriesvideos',
  templateUrl: './seriesvideos.component.html',
  styleUrls: ['./seriesvideos.component.scss']
})
export class SeriesvideosComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  @ViewChild('basicActions') basicActions: TemplateRef<BasicActionsComponent>;
  message = '';
  editSeriesvideo=null;
  modalid="newseriesvideo"
  modalid1="deletecommon"
  deleteid=""
  attributeList: any;
  rulesList: any = []
  rules: any = ""
  levelsList: any = []
  levels: any = ""
  categoryList: any = []
  category: any = ""
  instructorsList: any = []
  instructor: any = ""
  disableLevel: boolean = true
  disableCategory: boolean = true
  disableinstructors: boolean = true
  filterableAttribtute:any={};
  attri : any = []
  
  dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  //dtOptions: DataTables.Settings = {};
  dtOptions: ADTSettings = {};
  
  constructor(public adminApi: AdminapiService,public webApi: WebapiService){

  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      $('table.dataTable').DataTable().clearPipeline().draw();
      //dtInstance.clearPipeline().draw()
      //dtInstance.clear().draw();
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  changeData(event){
    this.rerender()
  }

  ngOnInit(): void {
    setTimeout(() => {
      const self = this;
      this.dtOptions = {
        serverSide: true,  
        ordering:false,
        searching:false,
        processing: true,
        lengthMenu:['10','20','30','40','50'],
        //order: [[0, 'desc']],
        //columnDefs: [{ targets: 3, orderable: false }],
        pageLength: 50,   // Set the flag 
        ajax: this.getSeriesVideos(),
        columns: [{
          title: 'ID',
          data: 'id'
        }, {
          title: 'Name',
          data: 'name'
        }, {
          title: 'Series Name',
          data: 'seriesname'
        }, {
          title: 'Featured',
          data: 'featured'
        }, {
          title: 'Trailer',
          data: 'trailor'
        }, {
          title: 'Sort Order',
          data: 'sort'
        }
        ,
        {
          title: 'Actions',
          data: null,
          ngTemplateRef: {
            ref: this.basicActions,
            context: {
              // needed for capturing events inside <ng-template>
              captureEvents: self.onCaptureEvent.bind(self),
            }
          }
        
        }
      ]
      };
      
    });
  }

  getSeriesVideos(){
    let params= {
      "instructor":this.instructor,
      "category":this.category
      // "attr":JSON.stringify(this.filterableAttribtute)
    }
    return this.adminApi.getSeriesVideos(params)
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      this.dtTrigger.next(this.dtOptions);
    }, 200);
  }

  onCaptureEvent(event: BasicActionsEventType) {
    //this.message = `Event '${event.cmd}' with data '${JSON.stringify(event.data)}`;
    if(event.cmd=='edit'){
      this.editSeriesvideo = event.data;
      this.openModal()
    }
    if(event.cmd=='delete'){
      this.deleteid = event.data.id;
      this.openConfirmModal()
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  addNewModal() {
    this.editSeriesvideo = null;

    this.openModal()
  }

  openModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  openConfirmModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid1)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid1), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  toLower(title){
    return title.toLowerCase().charAt(0).toUpperCase() + title.toLowerCase().slice(1);;
  }


  search(){
    const self = this;
    
    this.dtOptions.ajax = this.getSeriesVideos()
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      $('table.dataTable').DataTable().clearPipeline();
      dtInstance.destroy(false);
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  resetSearch(){
    this.category = "";
    this.instructor = "";
    setTimeout( ()=> {
      $('.selectpicker.instructor, .selectpicker.category').selectpicker('refresh');
      this.dtOptions.ajax = this.getSeriesVideos()
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Destroy the table first
        $('table.dataTable').DataTable().clearPipeline();
        dtInstance.destroy(false);
        // Call the dtTrigger to rerender again
        this.dtTrigger.next(this.dtOptions);
      });
    }, 0);
  }

}
